module.exports = __webpack_public_path__ + "static/media/fruits_38.736407f5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_38.csv
// module id = 704
// module chunks = 0